import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { subTenantData } from '../../../../shared/models/subtenant-selection';
import { SignupService } from '../../service/signup.service';
import { AuthConnectService } from '../../service/auth-connect.service';
import { Utils } from 'src/app/shared/utilities/utils';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';


@Component({
  selector: 'app-subtenant-selection',
  templateUrl: './subtenant-selection.component.html',
  styleUrls: ['./subtenant-selection.component.scss']
})
export class SubtenantSelectionComponent implements OnInit {
  constructor(
    private tenantService: TenantService,
    private signupService: SignupService,
    private authconnectService: AuthConnectService
  ){}

  @Output() subtenantClick = new EventEmitter<any>();
  subtenantData!: subTenantData[];
  tenantName!: string;

  ngOnInit(): void {
    this.authconnectService.getSubtenantFromURL().subscribe((data:any)=>{
      const _subTenantData = data.res
      _subTenantData.forEach((subtenant:any)=>{
        subtenant.img = subtenant.signupAvatarImageUrl
        subtenant.text = subtenant.subTenantName
      })
      this.subtenantData = Utils.sortItems(_subTenantData, 'rank', false);
      if(data.subTenant)  this.subtenantClick.emit(data?.subTenant?.id);
    })

    this.tenantService.getTenantAppConfig().subscribe((data: any) => {
      this.tenantName = data.name ?? '';
    });
  }

  navigateBack(): void {
    // go to getting started page
    const gettingStarted = this.signupService.getSignupEnum()?.getting_started
    this.signupService.setSignUpPageCount(gettingStarted)
  }

  onSubtenantClick(data: any): void {
    this.subtenantClick.emit(data.id);
    this.authconnectService.updateTenantCustomizationCSS(data);
  }

  clicked(e:any): void {
    if(e.action==='back') this.navigateBack()
    if(e.action==='selected') this.onSubtenantClick(e.data)
  }

}
